module.exports = __webpack_public_path__ + "static/media/cleverbots.43ca8edb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/img/cleverbots.svg
// module id = 356
// module chunks = 0